var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":"xl"}},[_c('div',{staticClass:"py-4 d-flex align-items-center"},[_c('div',{staticClass:"h3 mr-4"},[_vm._v(" Результат работы анализатора КТГ ")])]),(_vm.loading)?_c('Preloader',{attrs:{"dots":true}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }